import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {APP_CONFIG} from '../../config';
import type {Coordinate, LocationStateType} from '../../types';
import {formatCoordinate} from '../../utils/location';

type SetLocationPayload = {
  coordinate: Coordinate;
  address: string;
};

const defaultCoordinate: Coordinate = {
  latitude: APP_CONFIG.location.latitude,
  longitude: APP_CONFIG.location.longitude,
};

const initialState: LocationStateType = {
  coordinate: APP_CONFIG.ui.showMenuByDefault ? defaultCoordinate : null,
  address: APP_CONFIG.ui.showMenuByDefault ? formatCoordinate(defaultCoordinate) : null,
  isAddressConfirmed: APP_CONFIG.ui.showMenuByDefault,
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setLocation: (state, action: PayloadAction<SetLocationPayload>) => {
      state.coordinate = action.payload.coordinate;
      state.address = action.payload.address;
      state.isAddressConfirmed = true;
    },
    resetLocation: (state) => {
      state.coordinate = null;
      state.address = null;
      state.isAddressConfirmed = false;
    },
  },
});

export const {setLocation, resetLocation} = locationSlice.actions;

export {locationSlice};
